import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as yup from 'yup';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';

interface IShipmentTypeContext {
    isLoading: boolean
    shipmentType: ShipmentType

    saveShipmentType: (shipmentType: ShipmentType) => void
}

export let shipmentTypeSchema = yup.object({
    shipmentTypeId: yup.string().nullable().default(null),
    code: yup.string().required().default('').label('Code'),
    description: yup.string().nullable().default('').label('Description')
});

type ShipmentType = yup.InferType<typeof shipmentTypeSchema>;

export let shipmentTypeContext = React.createContext({} as IShipmentTypeContext);

let { Provider } = shipmentTypeContext;

let ShipmentTypeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { id } = useParams<{ id: string }>();
    let location = useLocation();
    let navigate = useNavigate();
    let { enqueueSnackbar } = useSnackbar();

    let isNew = location.pathname.includes("/addnew");

    let [isLoading, setLoading] = useState<boolean>(isNew === false);
    let [shipmentType, setShipmentType] = useState<ShipmentType>(shipmentTypeSchema.getDefault());
    let [isSaving, setSaving] = useState(false);


    useEffect(() => {
        if (isNew === false)
            getShipmentType();

    }, [id, isNew])

    let getShipmentType = async () => {
        try {
            let res = await axios.get('/api/ShipmentType/GetShipmentType', { params: { shipmentTypeId: id } });

            let { item } = res.data;
            setShipmentType({
                ...item,
            });
            setLoading(false);

        } catch (err) { }
        finally {
        }
    }

    let saveShipmentType = async (value: ShipmentType) => {
        try {
            await axios.post('/api/ShipmentType/UpdateShipmentType', value);
            enqueueSnackbar("Shipment Type saved", { variant: "success" });
            navigate(`/admin/shipmenttypes`);

        } catch (err) {
            setSaving(false)
        }
    }

    return (
        <Provider
            value={{
                isLoading,
                shipmentType,

                saveShipmentType
            }}
        >
            {children}
        </Provider>
    )
}

export default ShipmentTypeProvider;